import axios from "axios";

export default axios.create({
  baseURL: process.env.GATSBY_BASE_URL,

  //baseURL: `//backend-staging.medanswers.com/api`,
});

//baseURL: `//backend-v2.medanswers.com/api/`,
